(function () {
  // Wigvana fix (2026-08-17): keep the MSRP / Loyalty / Perfect 10 prices in sync with the selected variant.
  // The variant JSON script tag inside <variant-picker> can be replaced wholesale (not just mutated in place)
  // by the theme's own variant-switching JS, so we observe broadly (subtree + childList on a stable ancestor)
  // and always re-query for the current script element fresh on every mutation, rather than holding a
  // reference to one specific node.
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function readVariant(script) {
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (err) {
      return null;
    }
  }

  function applyVariant(root, variant) {
    if (!variant || typeof variant.price !== 'number') return;

    var msrp = variant.price;
    var loyalty = Math.round(msrp * 0.8);
    var perfect10 = Math.round(msrp * 0.72);

    var priceEls = root.querySelectorAll('.purchase-option__price');
    if (priceEls[0]) priceEls[0].textContent = formatMoney(msrp);
    if (priceEls[1]) priceEls[1].textContent = formatMoney(loyalty);
    // Wigvana fix (2026-09-11): for Wigvana house-brand products the third price slot is no longer Perfect 30 --
    // it's the fixed $25 Try Before You Buy CTA (see perfect10-price-ladder.liquid, purchase-option--tbyb-cta).
    // That price is a flat program fee, not derived from the variant's MSRP, so it must never be overwritten by
    // this sync. Guard by checking whether the third price element lives inside the TBYB CTA box.
    if (priceEls[2] && !priceEls[2].closest('.purchase-option--tbyb-cta')) {
      priceEls[2].textContent = formatMoney(perfect10);
    }
  }

  function findVariantScript(scope) {
    return scope.querySelector('variant-picker script[data-variant]') || document.querySelector('variant-picker script[data-variant]');
  }

  function initRoot(root) {
    var scope = root.closest('.product-info') || document;
    var observeTarget = scope.querySelector('variant-picker') || scope;

    function sync() {
      applyVariant(root, readVariant(findVariantScript(scope)));
    }

    sync();

    var observer = new MutationObserver(sync);
    observer.observe(observeTarget, { childList: true, subtree: true, characterData: true });

    // Belt-and-suspenders: some themes dispatch a bubbling custom event on variant change instead of
    // (or in addition to) rewriting the DOM. Listening for the common event names costs nothing if they
    // never fire, and catches cases the MutationObserver alone might miss.
    ['variant:change', 'variant-change', 'change'].forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        setTimeout(sync, 0);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-testid="perfect10-purchase-options"]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
